// @TODO: <HEALTH2019>
(function () {
    App.directive('uploadFile', uploadFile);
    uploadFile.$inject = ['Config'];

    function uploadFile(Config) {
        return {
            restrict: 'E',
            scope: {
                busy: '=',
                fileSelected: '&',
                uploadError: '&',
                formats: '@',
                /**
                 * In MB;
                 */
                maxSize: '<'
            },
            templateUrl: Config.TEMPLATES_DIR + 'Components/upload-file.html',
            bindToController: true,
            controller: UploadFileController,
            controllerAs: '$ctrl'
        }
    }

    UploadFileController.$inject = [];

    function UploadFileController() {
        var self = this;
        self.calculatedMaxSize = 3 * 1024 * 1024;

        self.uploadFiles = function (files) {
            if (!files || !files.length) return;
            try {
                for (var i = 0; i < files.length; i++) {
                    if (files[i].size > self.calculatedMaxSize) throw new Error('FILE_IS_TOO_BIG');
                    if (self.formats && !files[i].type) throw new Error('FILE_WRONG_FORMAT');
                    if (self.formats && self.formats.indexOf(files[i].type) === -1) throw new Error('FILE_WRONG_FORMAT');
                }

                self.fileSelected && self.fileSelected({$event: files});
            } catch (e) {

                switch (e.message) {
                    case 'FILE_IS_TOO_BIG':
                        self.uploadError && self.uploadError({$event: 'FILE_IS_TOO_BIG'});
                        break;
                    case 'FILE_WRONG_FORMAT':
                        self.uploadError && self.uploadError({$event: 'FILE_WRONG_FORMAT'});
                        break;
                    default:
                        self.uploadError && self.uploadError({$event: 'FILE_DEFAULT_ERROR'});
                }
            }
        };

        self.$onChanges = function (changes) {
            if (changes.maxSize) {
                self.calculatedMaxSize = (self.maxSize || 3) * 1024 * 1024;
            }
        };
    }
})();
// @TODO: </HEALTH2019>

